import { toNumber, toString } from 'lodash';

export enum ValueType {
    Number = 'number',
    String = 'string',
    Boolean = 'boolean',
}

const DEFAULT_CONFIG_FILE_NAME = 'app-config.json';

export function getConfigUrl(): string {
    const fileName =
        import.meta.env.VITE_CONFIG_FILE_NAME || DEFAULT_CONFIG_FILE_NAME;
    return `${window.location.origin}/${fileName}`;
}

export function castToNumber(value: unknown): number {
    const num = toNumber(value);
    return isNaN(num) ? 0 : num;
}

export function castToBoolean(value: unknown): boolean {
    if (typeof value === 'string') {
        const lower = value.toLowerCase();
        return lower === 'true' || lower === '1';
    }
    return Boolean(value);
}

export function mergeConfigs<T extends Record<string, unknown>>(
    cached: T,
    server: T,
): T {
    return { ...cached, ...server };
}

export function castValue(
    value: unknown,
    valueType: ValueType,
): string | number | boolean {
    if (value === null || value === undefined) {
        switch (valueType) {
            case ValueType.Number:
                return 0;
            case ValueType.Boolean:
                return false;
            default:
                return '';
        }
    }

    switch (valueType) {
        case ValueType.Number:
            return castToNumber(value);
        case ValueType.Boolean:
            return castToBoolean(value);
        default:
            return toString(value);
    }
}
